/**
 * A config containing properties for about modal
 */
var AboutModalConfig = /** @class */ (function () {
    function AboutModalConfig() {
    }
    return AboutModalConfig;
}());
export { AboutModalConfig };
//# sourceMappingURL=about-modal-config.js.map